// FETCH ALL PROPERTIES FROM ACCESSORIES_DC DETAILS
export const FETCH_ACCESSORIES_DC_DETAILS_REQUEST_DK = 'FETCH_ACCESSORIES_DC_DETAILS_REQUEST_DK';
export const FETCH_ACCESSORIES_DC_DETAILS_SUCCESS_DK = 'FETCH_ACCESSORIES_DC_DETAILS_SUCCESS_DK';
export const FETCH_ACCESSORIES_DC_DETAILS_FAILURE_DK = 'FETCH_ACCESSORIES_DC_DETAILS_FAILURE_DK';

// FETCH ALL PROPERTIES FROM ACCESSORIES_DC DETAILS BY ID
export const FETCH_ACCESSORIES_DC_DETAILS_BY_ID_REQUEST_DK = 'FETCH_ACCESSORIES_DC_DETAILS_BY_ID_REQUEST_DK';
export const FETCH_ACCESSORIES_DC_DETAILS_BY_ID_SUCCESS_DK = 'FETCH_ACCESSORIES_DC_DETAILS_BY_ID_SUCCESS_DK';
export const FETCH_ACCESSORIES_DC_DETAILS_BY_ID_FAILURE_DK = 'FETCH_ACCESSORIES_DC_DETAILS_BY_ID_FAILURE_DK';

// CREATE PROPERTIES FOR ACCESSORIES_DC DETAILS
export const CREATE_ACCESSORIES_DC_DETAILS_REQUEST_DK = 'CREATE_ACCESSORIES_DC_DETAILS_REQUEST_DK';
export const CREATE_ACCESSORIES_DC_DETAILS_SUCCESS_DK = 'CREATE_ACCESSORIES_DC_DETAILS_SUCCESS_DK';
export const CREATE_ACCESSORIES_DC_DETAILS_FAILURE_DK = 'CREATE_ACCESSORIES_DC_DETAILS_FAILURE_DK';

//CREATE USER FORM
export const CREATE_USER_FORM_ACCESSORIES_DC_DETAILS_DK = 'CREATE_USER_FORM_ACCESSORIES_DC_DETAILS_DK';

// UPDATE PROPERTIES FOR ACCESSORIES_DC DETAILS
export const UPDATE_ACCESSORIES_DC_DETAILS_REQUEST_DK = 'UPDATE_ACCESSORIES_DC_DETAILS_REQUEST_DK';
export const UPDATE_ACCESSORIES_DC_DETAILS_SUCCESS_DK = 'UPDATE_ACCESSORIES_DC_DETAILS_SUCCESS_DK';
export const UPDATE_ACCESSORIES_DC_DETAILS_FAILURE_DK = 'UPDATE_ACCESSORIES_DC_DETAILS_FAILURE_DK';

// FETCH SINGLE ACCESSORIES_DC_DETAILS
export const FETCH_SINGLE_ACCESSORIES_DC_DETAILS_REQUEST_DK = 'FETCH_SINGLE_ACCESSORIES_DC_DETAILS_REQUEST_DK';
export const FETCH_SINGLE_ACCESSORIES_DC_DETAILS_SUCCESS_DK = 'FETCH_SINGLE_ACCESSORIES_DC_DETAILS_SUCCESS_DK';
export const FETCH_SINGLE_ACCESSORIES_DC_DETAILS_FAILURE_DK = 'FETCH_SINGLE_ACCESSORIES_DC_DETAILS_FAILURE_DK';

// DELETE PROPERTIES FOR ACCESSORIES_DC DETAILS
export const DELETE_ACCESSORIES_DC_DETAILS_REQUEST_DK = 'DELETE_ACCESSORIES_DC_DETAILS_REQUEST_DK';
export const DELETE_ACCESSORIES_DC_DETAILS_SUCCESS_DK = 'DELETE_ACCESSORIES_DC_DETAILS_SUCCESS_DK';
export const DELETE_ACCESSORIES_DC_DETAILS_FAILURE_DK = 'DELETE_ACCESSORIES_DC_DETAILS_FAILURE_DK';

export const FETCH_ACCESSORIES_DC_PREVIOUS_LIST_REQUEST_DK = 'FETCH_ACCESSORIES_DC_PREVIOUS_LIST_REQUEST_DK';
export const FETCH_ACCESSORIES_DC_PREVIOUS_LIST_SUCCESS_DK = 'FETCH_ACCESSORIES_DC_PREVIOUS_LIST_SUCCESS_DK';
export const FETCH_ACCESSORIES_DC_PREVIOUS_LIST_FAILURE_DK = 'FETCH_ACCESSORIES_DC_PREVIOUS_LIST_FAILURE_DK';

// USERFORM RESET

export const ACCESSORIES_DC_DETAILS_USERFORM_RESET_DK = 'ACCESSORIES_DC_DETAILS_USERFORM_RESET_DK';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_GRN_NO_BY_ACCESSORIES_PO_REQUEST_DK = 'FETCH_GRN_NO_BY_ACCESSORIES_PO_REQUEST_DK';
export const FETCH_GRN_NO_BY_ACCESSORIES_PO_SUCCESS_DK = 'FETCH_GRN_NO_BY_ACCESSORIES_PO_SUCCESS_DK';
export const FETCH_GRN_NO_BY_ACCESSORIES_PO_FAILURE_DK = 'FETCH_GRN_NO_BY_ACCESSORIES_PO_FAILURE_DK';


// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_ACCESSORIES_DC_DETAILS_STYLE_REQUEST_DK = 'FETCH_ACCESSORIES_DC_DETAILS_STYLE_REQUEST_DK';
export const FETCH_ACCESSORIES_DC_DETAILS_STYLE_SUCCESS_DK = 'FETCH_ACCESSORIES_DC_DETAILS_STYLE_SUCCESS_DK';
export const FETCH_ACCESSORIES_DC_DETAILS_STYLE_FAILURE_DK = 'FETCH_ACCESSORIES_DC_DETAILS_STYLE_FAILURE_DK';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_ACCESSORIES_PO_IN_ACCESSORIES_DC_REQUEST_DK = 'FETCH_ACCESSORIES_PO_IN_ACCESSORIES_DC_REQUEST_DK';
export const FETCH_ACCESSORIES_PO_IN_ACCESSORIES_DC_SUCCESS_DK = 'FETCH_ACCESSORIES_PO_IN_ACCESSORIES_DC_SUCCESS_DK';
export const FETCH_ACCESSORIES_PO_IN_ACCESSORIES_DC_FAILURE_DK = 'FETCH_ACCESSORIES_PO_IN_ACCESSORIES_DC_FAILURE_DK';


export const FETCH_ACCESSORIES_DC_DETAILS_IRONPACK_REQUEST_DK = 'FETCH_ACCESSORIES_DC_DETAILS_IRONPACK_REQUEST_DK';
export const FETCH_ACCESSORIES_DC_DETAILS_IRONPACK_SUCCESS_DK = 'FETCH_ACCESSORIES_DC_DETAILS_IRONPACK_SUCCESS_DK';
export const FETCH_ACCESSORIES_DC_DETAILS_IRONPACK_FAILURE_DK = 'FETCH_ACCESSORIES_DC_DETAILS_IRONPACK_FAILURE_DK';

export const FETCH_ACCESSORIES_DC_DETAILS_STITCHING_REQUEST_DK = 'FETCH_ACCESSORIES_DC_DETAILS_STITCHING_REQUEST_DK';
export const FETCH_ACCESSORIES_DC_DETAILS_STITCHING_SUCCESS_DK = 'FETCH_ACCESSORIES_DC_DETAILS_STITCHING_SUCCESS_DK';
export const FETCH_ACCESSORIES_DC_DETAILS_STITCHING_FAILURE_DK = 'FETCH_ACCESSORIES_DC_DETAILS_STITCHING_FAILURE_DK';